import { ArrayHelper } from "../core/array.helper";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

import * as dataCore from "../core/datacore";

type MultiSelectEntity = Nema.Crew.Model.NameSortTagId;

@Component({
    selector: "crew-hierarchical-multiselect",
    template: require('./hierarchical-multiselect.component.html')
})
export class HierarchicalMultiSelectComponent implements OnChanges {

    constructor(private arrayHelper: ArrayHelper) { }

    @Input()
    label: string;

    @Input()
    getChildItems: (parent: MultiSelectEntity) => MultiSelectEntity[];

    @Input()
    getChildDisplayName: (child: MultiSelectEntity) => string;

    @Input()
    height: string;

    @Input()
    availableParentItems: MultiSelectEntity[];

    @Input()
    selectedChildItems: MultiSelectEntity[];

    markedAvailableChildItems: MultiSelectEntity[] = [];
    markedSelectedChildItems: MultiSelectEntity[] = [];

    private hierarchyMap: Map<number, MultiSelectEntity[]>;

    addMarkedItems(): void {
        this.addItems(this.markedAvailableChildItems);
    }

    addAllItems(): void {
        for (const childItems of dataCore.orderBySortTagThenName(this.availableParentItems).map(parent => this.getRemainingChildItems(parent))) {
            this.addItems(dataCore.orderBySortTagThenName(childItems));
        }
    }

    removeMarkedItems(): void {
        this.removeItems(this.markedSelectedChildItems);
    }

    removeAllItems(): void {
        this.removeItems(this.selectedChildItems);
    }

    get availableParentItemsWithChildren(): MultiSelectEntity[] {
        return this.availableParentItems ?
            this.availableParentItems.filter(parent => this.hasChildItems(parent)) :
            [];
    }

    getRemainingChildItems(parent: MultiSelectEntity): MultiSelectEntity[] {
        if (!this.hierarchyMap || !this.hierarchyMap.has(parent.Id)) {
            return [];
        }

        return this.hierarchyMap.get(parent.Id).filter(child => !this.selectedChildItems.some(selectedChild => selectedChild.Id === child.Id));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.availableParentItems && changes.availableParentItems.currentValue && this.availableParentItems) {
            this.initialize();
        }
    }

    private initialize(): void {
        this.hierarchyMap = new Map<number, MultiSelectEntity[]>();

        for (const parent of this.availableParentItems) {

            const childItems = this.getChildItems(parent);
            this.hierarchyMap.set(parent.Id, childItems);
        }
    }

    private addItems(childItems: MultiSelectEntity[]) {
        this.arrayHelper.addItems(childItems, this.selectedChildItems);
        this.markedAvailableChildItems = [];
    }

    private removeItems(childItems: MultiSelectEntity[]) {
        this.arrayHelper.removeItems(childItems, this.selectedChildItems);
        this.markedSelectedChildItems = [];
    }

    private hasChildItems(parent: MultiSelectEntity): boolean {
        return !!this.getRemainingChildItems(parent).length;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/hierarchical-multiselect.component.ts